// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XvaG","tabsBox":"styles_tabsBox__3axMe","createButton":"styles_createButton__IWb2m"};